import { FC, useEffect, useState } from 'react';
import { DetailHeader } from '../common/DetailHeader';
import { QcsTypography } from '../common/basic/QcsTypography';
import { useAppSelector } from '../../store';
import { selectIdentity } from '../../store/entities/identity';
import { supplierEmployeeService } from '@api/services/services';
import { ShowError } from '../ShowError';
import { resources } from '@api/resources';
import { ShowResourceContent } from '../ShowResourceContent';

export const PinExternal: FC = () => {
  const [pin, setPin] = useState('');
  const identity = useAppSelector(selectIdentity);

  useEffect(() => {
    (async () => {
      const pin = await supplierEmployeeService.revealPin(identity.id);
      setPin(pin.data.pin!);
    })();
  }, [identity.id]);

  return (
    <ShowResourceContent resource={resources.revealPin}>
      <DetailHeader title="mainMenu.pinExternal" />
      <ShowError resource={resources.revealPin} />
      {pin && <QcsTypography variant="h4">{pin}</QcsTypography>}
    </ShowResourceContent>
  );
};
